module.exports = __webpack_public_path__ + "img/100.8.d91fef12.png";